import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useMemes } from "./context/MemesContext";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookSquare,
  faInstagramSquare,
  faWhatsappSquare,
  faTwitterSquare
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MemesShow = (props: any) => {
	let { meme_identifier } = useParams();
	const { meme, getMeme } = useMemes();

	useEffect(() => {
	  if (meme_identifier) {
	    getMeme(meme_identifier)
	  }
	}, [meme_identifier]);
	
	const meme_url = `${process.env.REACT_APP_PURRS_API_HOST}/m/${meme.identifier}`;

	console.log(meme.identifier)
	return(
		<>
			<div className="grid-container">
				<div className="grid-x grid-margin-x">
					<div className="cell medium-6">
						<div className="meme-item" style={{backgroundImage: `url(${meme.image_url})`}}></div>
					</div>
					<div className="cell medium-6">
						<div className="hide-for-small-only">
							<h2>Сподели</h2>
							<p>Сподели във Facebook, Instagram или с приятели чрез бутони по-долу, като копираш линк или като свалиш снимков файл: </p>
						</div>
						<a href={`https://facebook.com/sharer/sharer.php?u=${meme_url}`} target="_blank" className="share-button--icon-only facebook-color"><FontAwesomeIcon icon={faFacebookSquare as IconProp} /></a>
						{meme.ig_post_url ? (
							<a href={`${meme.ig_post_url}`} className="share-button--icon-only instagram-color"><FontAwesomeIcon icon={faInstagramSquare as IconProp}  /></a>						
						) : ""}
						<a href={`https://twitter.com/intent/tweet/?text=${meme_url}`} className="share-button--icon-only twitter-color"><FontAwesomeIcon icon={faTwitterSquare as IconProp}  /></a>
						<a href={`whatsapp://send?text=${meme_url}`} className="share-button--icon-only whatsapp-color"><FontAwesomeIcon icon={faWhatsappSquare as IconProp}  /></a>
						
						<hr className="small-spacing" />

						<input type="text" value={meme_url} />					
						
						<hr className="small-spacing" />
						
						<a href={meme.image_url} className="button secondary no-margin hollow wide" download>Свали файл</a>

					</div>
				</div>
			</div>
		</>
	)
};

export default MemesShow;
